<template>
    <div>
        <slot name="activator" v-bind="{on: {click: onShare}}">
            <v-btn
                :icon="!Boolean(buttonLabel)"
                @click.prevent="onShare"
                :color="color"
                :disabled="disabled"
                :text="buttonText"
                :dark="buttonThemeDark"
            >
                <v-icon :color="color" :size="iconSize">fas fa-share-alt</v-icon>
                <template v-if="buttonLabel">{{buttonLabel}}</template>
            </v-btn>
        </slot>

        <v-dialog v-if="dialog" v-model="dialog" width="600" :attach="attachModal" :hide-overlay="hideOverlay">
            <v-card>
                <v-card-title>
                    {{$t(dialogTitle)}}

                    <v-spacer/>

                    <v-btn icon @click="dialog = false" color="primary">
                        <v-icon> fas fa-times</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout row wrap>
                            <v-flex grow>
                                <whats-app-share :url="url" block />
                            </v-flex>

                            <v-flex grow>
                                <facebook-share :app-id="facebookAppId" :url="url" block />
                            </v-flex>

                            <v-flex grow>
                                <email-share :url="url" block :subject="emailSubject" :body="emailBody" />
                            </v-flex>

                            <v-flex grow>
                                <copy-link :url="url" block />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <slot name="overlay" v-bind="{showOverlay: dialog}"/>
    </div>
</template>

<script>
import { Capacitor} from '@capacitor/core';
import { Share } from '@capacitor/share';
import FacebookShare from './FacebookShare';
import EmailShare from './EmailShare';
import CopyLink from './CopyLink';
import WhatsAppShare from './WhatsAppShare';

export default {
    components: {
        FacebookShare,
        EmailShare,
        CopyLink,
        WhatsAppShare,
    },
    props: {
        url: String,
        title: String,
        emailSubject: String,
        emailBody: String,
        media: String,
        color: {
            default: 'primary',
            type: String,
        },
        dialogTitle: {
            type: String,
            default: 'Share',
        },
        iconSize: String,
        disabled: Boolean,
        buttonLabel: String,
        attachModal: {
            default: undefined,
        },
        hideOverlay: Boolean,
        buttonText: Boolean,
        buttonThemeDark: Boolean,
    },
    created() {
            if (Capacitor.platform === 'android') {
                this.shareService = Share;
            } else if (
                window &&
                window.navigator &&
                window.navigator.share &&
                window.navigator.platform.indexOf('Win') == -1
            ) {
                this.shareService = window.navigator;
            }
    },
    data() {
        return {
            dialog: false,
            nativeShareModel: null,
            facebookAppId: process.env.VUE_APP_FACEBOOK_APP_ID,
        };
    },
    methods: {
        onShare() {
            if (this.shareService) {
                this.shareService.share({
                    url: this.url,
                    title: this.title,
                    dialogTitle: this.dialogTitle,
                })
                    .then(() => {})
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                this.dialog = true;
            }
        },
    },
};
</script>
